module.exports = __webpack_public_path__ + "static/media/Different World.05af2500.txt";